export const cloudimageConfig = {
    token: 'ammzjgqroq',
    baseURL: '_pixt-poc_',
    url: '.cloudimg.io/v7'
};
